<template>
  <div class="embed-responsive">
    <Title :title-name="pageTitle.titleName" :title-link="pageTitle.titleLink" />
    <div class="container-fluid">
      <iframe style="margin-top: 54px" :src="iframeUrl" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'

export default {
  name: 'MyDocument',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pageTitle: {},
      iframeUrl: ''
    }
  },
  computed: {
    ...mapGetters({
      Cmtpax: ''
    })
  },
  watch: {
    title: function (el) {
      if (el && el.IframePopup) {
        this.pageTitle = el.IframePopup
      }
    }
  },
  created() {
    this.iframeUrl = this.$route.query.url
    if (this.title && this.title.IframePopup) {
      this.pageTitle = this.title.IframePopup
    }
  }
}
</script>
